import Menu from '../menu/Menu';
import { HeaderStyle } from './header-style';

interface IHeaderProps {
  showNotifications?: boolean;
}

const Header: React.FC<IHeaderProps> = () => {
  return (
    <HeaderStyle>
      <div className="header-container">
        <Menu />
      </div>
    </HeaderStyle>
  );
};

export default Header;
